import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ProductSettingPairs extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    const bandData = [
      {
        image: '/img/productpage/Image70.png',
        description: 'Nexus Wedding Band',
        price: 1099,
      },
      {
        image: '/img/productpage/Image71.png',
        description: 'Oko Wedding Band',
        price: 2499,
      },
      {
        image: '/img/productpage/Image73.png',
        description: 'Tacori Solitaire Ring',
        price: 768,
      },
    ];

		this.state = {
      bands: bandData,
      expanded: false,
    };
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

	render() {
		return <div className='ProductSettingPairs'>
      <div className='productPairsHeader' onClick={::this.toggleExpanded}>
        <div className='productPairsTitle'>Pairs Well With</div>
        {this.state.expanded ?
          <div className='headerIcon'>&mdash;</div> :
          <div className='headerIcon'>+</div>
        }
      </div>
      <div className={this.state.expanded ? 'productPairsWrapper expanded' : 'productPairsWrapper'}>
        {this.state.bands.map((band, i) => {
          return <div className='settingItemWrapper' key={i}>
            <div className='settingItemInnerWrapper'>
              <div className='settingImageWrapper'>
                <img src={band.image} />
              </div>
              <div className='settingInfoWrapper'>
                <div className='settingTitleWrapper'><div>{band.description}</div></div>
                <div className='settingPrice'>${band.price.toLocaleString()}</div>
              </div>
            </div>
          </div>;
        })}
      </div>
		</div>;
	}
}
export default ProductSettingPairs;

function mapStateToProps(state) {
  return {

  };
}

export const ProductSettingPairsContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductSettingPairs);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductSettingPairs.jsx